<template>
    <div class="w-full flex items-start gap-x-5">
        <div class="rounded-lg min-w-[30%] bg-white p-10 text-black">
            <h2 class="text-2xl font-extralight underline">Remplir les champs suivants :</h2>
            <form @submit.prevent="saveForm" class="mt-8">
                <div class="w-full flex flex-col items-start ">
                    <label for="name" class="font-light" >Nom<span class="text-[#f44545]">*</span></label>
                    <input type="text" v-model="form.nom" name="name" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none" placeholder="John">
                </div>
                <div class="w-full flex flex-col pt-4 text-black">
                    <label for="departement" class="font-light" >Département<span class="text-[#f44545]">*</span></label>
                    <input type="text" v-model="form.departement" placeholder="departement" name="departement" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                </div>
                <div class="w-full flex flex-col pt-4 text-black">
                    <label for="debut" class="font-light" >Début congé<span class="text-[#f44545]">*</span></label>
                    <input type="date" v-model="form.startDate" placeholder="" name="debut" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                </div>
                <div class="w-full flex flex-col pt-4 text-black">
                    <label for="fin" class="font-light" >Fin congé<span class="text-[#f44545]">*</span></label>
                    <input type="date" v-model="form.endDate" placeholder="" name="fin" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                </div>
                <div class="w-full flex flex-col pt-4 text-black">
                    <label for="returnD" class="font-light" >Date retour<span class="text-[#f44545]">*</span></label>
                    <input type="date" v-model="form.returnDate" placeholder="" name="returnD" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                </div>

                <div class="w-full flex flex-col pt-4 text-black">
                    <label for="nbjour" class="font-light" >Nombre de jour<span class="text-[#f44545]">*</span></label>
                    <input type="number" v-model="form.nbJour" placeholder="" name="nbjour" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                </div>
                <div class="w-full flex flex-col pt-4 text-black">
                    <label for="raison" class="font-light" >Raison<span class="text-[#f44545]">*</span></label>
                    <input type="text" v-model="form.raison" placeholder="" name="raison" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                </div>
                    <button type="submit" :disabled="asSend" class="w-full mt-8 py-3 bg-[#5357ec] text-white rounded-md">
                        <Loader2 v-if="asSend" class="animate-spin mx-auto"/>
                        <span v-if="!asSend">Enregistrer</span>
                    </button>
            </form>
        </div>
        <div class="rounded-lg grow min-h-[850px] bg-white">
            <div class="mx-auto w-[89%] rounded-lg px-7 py-8 mt-10">
                <!-- <div class="w-full flex justify-center mt-14 mb-20">
                    <img src="../../../../assets/uigb-logo.png" alt="logo uigb" class="h-20 w-auto object-cover">
                </div> -->
                <h2 class="text-3xl font-medium text-center mb-[40px] text-black underline">ATTESTATION DE DEPART EN CONGES MATERNITE</h2>
                <table class="table table-bordered">
                    <thead>
                        <tr>
                            <th class="text-2xl text-black font-normal w-1/3">Name</th>
                            <th class="text-2xl text-black font-normal">{{ form.nom ?? "" }}</th>
                        </tr>
                        <tr>
                            <th class="text-2xl text-black font-normal w-1/3">Department serviced</th>
                            <th class="text-2xl text-black font-normal">{{ form.departement ?? "" }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th colspan="2" class="text-center text-black text-3xl font-semibold">DATES/REASONS OF ABSENCE</th>
                        </tr>
                        <tr>
                            <th class="text-2xl text-black font-normal">From</th>
                            <th class="text-2xl text-black font-normal">{{ form.startDate ?? "" }}</th>
                        </tr>
                        <tr>
                            <th class="text-2xl text-black font-normal">To</th>
                            <th class="text-2xl text-black font-normal">{{ form.endDate ?? "" }}</th>
                        </tr>
                        <tr>
                            <th class="text-2xl text-black font-normal">Return Date</th>
                            <th class="text-2xl text-black font-normal">{{ form.returnDate ?? "" }}</th>
                        </tr>
                        <tr>
                            <th class="text-2xl text-black font-normal">Number of Days</th>
                            <th class="text-2xl text-black font-normal">{{ form.nbJour ?? "" }}</th>
                        </tr>
                        <tr>
                            <th class="text-2xl text-black font-normal">Reason</th>
                            <th class="text-2xl text-black font-normal">{{ form.raison ?? "" }}</th>
                        </tr>
                    </tbody>
                </table>
                <p class="mb-4 text-gray-700 mt-28 ml-8">
                    Consultant’s signature: .............................
                </p>
                <p class="mb-4 text-gray-700 mt-28 ml-8">
                    Supervisor signature: .............................
                </p>
                <p class="mb-4 text-gray-700 mt-28 ml-8">
                    HR Office signature: .............................
                </p>
            </div>
        </div>
    </div>
</template>
<script>
import {Loader2} from "lucide-vue-next";
import API from "@/service/API";
import toast from "@/components/ui/toast";
export default {
    name: "ConsultantAbsenceNot",
    components: {Loader2},
    data() {
        return {
            asSend: false,
            form: {
                nom: null,
                departement: null,
                startDate: null,
                endDate: null,
                returnDate: null,
                nbJour: null,
                raison: null,
            }
        };
    },
    methods: {
        clearForm() {
            this.form.nom = null;
            this.form.departement = null;
            this.form.startDate = null;
            this.form.endDate = null;
            this.form.returnDate = null;
            this.form.nbJour = null;
            this.form.raison = null;
        },
        saveForm(){
            this.asSend = true;
            const data = {
                "content" : JSON.stringify(this.form),
                "doc_id":19,
                "user_id": localStorage.getItem("userId") ?? this.$store.getters.userId
            }
            API.post("user-docs", data)
                .then((response) => {
                    if(response.data["status"] == 'success'){
                        toast.success("Succès","Demande enregistré avec succès",4000)
                        this.clearForm();
                    }else{
                        toast.error("Oops..",response.data["message"],4000)
                    }
                })
                .catch(() => {
                    toast.error("Oops..","Il semble avoir une erreur, merci de réessayé.",4000)
                }).finally(()=>{
                    this.asSend = false;
                });
        }
    },
}
</script>